export default __webpack_public_path__ + "static/media/Disponibilidade.38ea1952.svg";